<template>
  <div class="accordion" role="tablist">
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1 raftjs-b4" role="tab">
        <b-button block v-b-toggle="id" variant="info" class="raftjs-b4">
          {{ label }}
          <svg
            v-show="collapsed"
            style="margin-left: auto"
            width="10"
            height="6"
            viewBox="0 0 10 6"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.52827 0.195262C0.788619 -0.0650874 1.21073 -0.0650874 1.47108 0.195262L4.99967 3.72386L8.52827 0.195262C8.78862 -0.0650874 9.21073 -0.0650874 9.47108 0.195262C9.73143 0.455612 9.73143 0.877722 9.47108 1.13807L5.47108 5.13807C5.21073 5.39842 4.78862 5.39842 4.52827 5.13807L0.52827 1.13807C0.26792 0.877722 0.26792 0.455612 0.52827 0.195262Z"
              fill="#00008C"
            />
          </svg>
        </b-button>
      </b-card-header>
      <b-collapse
        :visible="!collapsed"
        :id="id"
        accordion="incident-investigation-drawers"
        role="tabpanel"
        style="padding-top: 0.5rem"
        :class="{ grid: isGrid }"
      >
        <b-card-body>
          <slot name="accordionFormFields" />
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "AccordionFormFields",
  components: {},
  props: {
    id: { type: String, required: true },
    label: { type: String, required: true },
    collapsed: { type: Boolean, default: true },
  },
  computed: {
    isGrid() {
      return this.id === "group_inc_invest_inj_ill_info";
    },
  },
};
</script>

<style scoped>
div.accordion {
  --accordion-bg-color: rgb(250, 250, 251);
  width: 100%;
  border: none;
  text-align: left;
  font-weight: bold;
  font-size: 14px;
  background-color: var(--accordion-bg-color, #ffffff);
}

#raft-js header.card-header.raftjs-b4 {
  background-color: var(--accordion-bg-color, #ffffff);
  margin: 0;
  padding: 0;
}

#raft-js header.card-header.raftjs-b4 button.raftjs-b4 {
  color: rgb(48, 68, 88);
  padding: 0.5rem;
  background-color: var(--accordion-bg-color, #ffffff);
  display: flex;
  align-items: center;
  margin-right: 0.25rem;
  transition: 0.1s;
}

#raft-js header.card-header.raftjs-b4 button.raftjs-b4.not-collapsed {
  text-decoration: underline;
}

#raft-js header.card-header.raftjs-b4 button.raftjs-b4:hover {
  background-color: rgb(240, 240, 250);
  text-decoration: underline;
}

#raft-js div.accordion div[role="tabpanel"].show {
  background-color: var(--accordion-bg-color, #ffffff);
  position: relative;
  padding: 0px 16px;
}
</style>
